import {gql} from "@apollo/client";

const universityDegreeLevelsQuery = gql`
    query UniversityDegreeLevelsQuery($universitySlug: String) {
        allDegreeLevels(universitySlug: $universitySlug) {
            id
            name
        }
    }
`;

export default universityDegreeLevelsQuery;
